import moment from 'moment/moment'

export interface SessionTimelineGroup<T> {
	dateLabel: string
	items: T[]
}

export function groupSessionTimelineByDate<T extends { created: string }>(items: T[]): SessionTimelineGroup<T>[] {
	const groups: SessionTimelineGroup<T>[] = []

	for (const item of items) {
		const dateLabel = moment(item.created).format('DD [de] MMMM [de] YYYY')
		const lastGroup = groups[groups.length - 1]

		if (lastGroup?.dateLabel === dateLabel) {
			lastGroup.items.push(item)
		} else {
			groups.push({ dateLabel, items: [item] })
		}
	}

	return groups
}

export function eventSourceIcon(sourceTag: string): string {
	switch (sourceTag) {
		case 'Anexos':
			return 'upload'
		case 'Diligência':
			return 'envelope'
		case 'Julgamento':
			return 'gavel'
		case 'Recurso/Contrarrazão':
			return 'scale-balanced'
		default:
			return 'circle-info'
	}
}
